// Templates that must not be offered in the manual "Send Email" dropdowns.
// - isPermanent: system emails sent by code (booking confirmed/updated/cancelled).
// - Person-specific invitations: hidden by name until they are removed or replaced with a placeholder template.
const HIDDEN_TEMPLATE_NAMES = new Set([
  'personal invitation - annika sorenstam',
  'personal invitation - antony scanlon',
  'personal invitation - peter dawson',
]);

export const filterSendableTemplates = (templates) =>
  (Array.isArray(templates) ? templates : []).filter(
    (t) => !t.isPermanent && !HIDDEN_TEMPLATE_NAMES.has(String(t.name || '').trim().toLowerCase())
  );
